import * as React from "react";
import {Channel} from "@models/channel";
import ChannelsTable from "@components/channels/Table";
import {Button, Card} from "antd";
import {FormattedMessage} from "react-intl";
import SearchChannelsComponent from "@components/channels/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import channelApi from "@api/channel";
import withPaginationComponent from "@hocs/withPaginationComponent";



interface PropsFromHoc {
  data          :Channel[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

const ChannelsIndexPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  
  const deleteChannel = (item: Channel): any => {
    const {onDeleteItem} = props;
    channelApi.delete({
        params: {id: item.id}
      })
      .then(() => {
        onDeleteItem(item.id)
      })
      .catch(error => console.log(error))
  };
  
  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/channels/create`}>
          <Button type={"primary"}>
            <FormattedMessage
              id="app.new_channel"
              defaultMessage={`Create Channel`}
            />
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchChannelsComponent search={search}/>
        </Card>
        
        <ChannelsTable
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteChannel}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ChannelsIndexPage),
  {
    fetchRequest: channelApi.getList,
    paginationOnScroll: false
  }
);
